import gql from "graphql-tag";
export var EarningStatus;
(function (EarningStatus) {
    EarningStatus["Claimable"] = "Claimable";
    EarningStatus["Claimed"] = "Claimed";
    EarningStatus["Cooldown"] = "Cooldown";
    EarningStatus["Expired"] = "Expired";
    EarningStatus["Pending"] = "Pending";
    EarningStatus["Unverified"] = "Unverified";
})(EarningStatus || (EarningStatus = {}));
export const GetPositionsDocument = gql `
  query getPositions($beneficiary: [String!]!) {
    positions(beneficiary: $beneficiary) {
      spentTxHash
      txHash
      index
      createdAt {
        format
      }
      spentTxHash
      spentAt {
        format
      }
      ownerID
      value {
        assetID
        amount
      }
      delegation {
        pool {
          poolIdent
          lpAsset
          assetA
          assetB
        }
        program {
          id
          label
          dailyEmission {
            assetID
            amount
          }
          firstDailyRewards {
            format
          }
          lastDailyRewards {
            format
          }
          emittedAsset
          stakedAsset
          eligiblePools {
            poolIdent
            lpAsset
            assetA
            assetB
          }
          disqualifiedPools {
            poolIdent
            lpAsset
            assetA
            assetB
          }
          minLPIntegerPercent
          maxPoolCount
          maxPoolIntegerPercent
        }
        weight
      }
    }
  }
`;
const defaultWrapper = (action, _operationName, _operationType) => action();
export function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getPositions(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetPositionsDocument, variables, {
                ...requestHeaders,
                ...wrappedRequestHeaders,
            }), "getPositions", "query");
        },
    };
}
//# sourceMappingURL=yield.sdk.js.map